import { format } from 'date-fns';
import type { GeneralMetricsData, GroupByPeriod } from '@/entities/Dashboard';
import type { AttendanceChartPoint } from '../ui/components/AttendanceEngagementChart/AttendanceEngagementChart';

const formatLabel = (iso: string, groupBy: GroupByPeriod): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  if (groupBy === 'month') return format(date, 'MMM');
  return format(date, 'd MMM');
};

export const toAttendanceChartPoints = (data?: GeneralMetricsData): AttendanceChartPoint[] => {
  if (!data?.data) return [];

  return Object.entries(data.data)
    .sort(([a], [b]) => new Date(a).getTime() - new Date(b).getTime())
    .map(([iso, value]) => ({
      month: formatLabel(iso, data.groupBy),
      attendance: value.attendance ?? 0,
      engagement: value.engagement ?? 0,
    }));
};
